import { api } from "./common";
import { Id } from "../types";
import { fetchOrgEntities } from "./fetch-org-entities";

type Props = { subscriptionId: Id; name: string; orgUnitId: Id };

type ApiResponse = {
  id: number;
};

export const addFunction = async (props: Props) => {
  const res = await api<ApiResponse>("v2/functions", {
    method: "POST",
    body: JSON.stringify({ name: props.name, departmentId: props.orgUnitId }),
    headers: { subscriptionid: props.subscriptionId.toString() },
  });

  const { functions } = await fetchOrgEntities(props.subscriptionId);

  return { functions, newFunctionId: res.id };
};
